/* src/app/forms/simple-form/simple-form.component.scss */
.main-content-edit {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: block;
  flex-direction: column;
}
/*# sourceMappingURL=simple-form.component.css.map */
